<template>
  <div class="list-group list-group-bordered" ref="list">
    <div class="list-group-header d-flex align-items-center"
         :class="{ 'justify-content-between': extraSmall || small, 'flex-column': extraSmall || small }"
         v-if="showHeader">
        <span :class="{ 'mb-2': extraSmall || small }">
          {{ researchers.length }} {{ researchers.length === 1 ? 'Coinvestigador externos' : 'Coinvestigadores externos' }} agregados
        </span>
    </div>
    <template v-if="researchers && researchers.length">
      <div v-for="researcher in researchers"
          class="list-group-item"
          :data-id="researcher.id"
          :key="researcher.id"
          :researcher="researcher"
          :readonly="readonly"
          :show-actions="!readonly"
           :show-name="showName"
          @remove-researcher="researcher => $emit('remove-researcher', researcher)"
          is="researcher-list-item">
      </div>
    </template>
  </div>
</template>

<script>
  import ResearcherListItem from './ResearcherListItem'
  
  export default {
    name: 'ExternalResearchersList',
    components: {
      ResearcherListItem,
    },
    props: {
      researchers: {
        type: Array,
        default: () => ([]),
      },
      showHeader: {
        type: Boolean,
        default: true,
      },
      readonly: {
        type: Boolean,
        default: false,
      },
      showName: {
        type: Boolean,
        default: false,
      },
    },
    data: () => ({}),
    methods: {},
    computed: {
      extraSmall () {
        return this.$mq === 'xs'
      },
      small () {
        return this.$mq === 'sm'
      },
    },
  }
</script>
